/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

const SliderIndicator = (props) => {
  const itemCount = props.itemCount; // how many total item of slider
  const currentIndex = props.currentIndex; // active slider index
  const indicatorStyle = props.indicatorStyle;
  const indicatorContainerStyle = props.indicatorContainerStyle;
  const indicatorActiveColor = props.indicatorActiveColor;
  const indicatorInActiveColor = props.indicatorInActiveColor;
  const indicatorActiveWidth = props.indicatorActiveWidth;
  const onChangeIndex = props.onChangeIndex; // on change active slider callback

  const indicators = [];
  for (let i = 0; i < itemCount; i++) {
    indicators.push(i);
  }

  const IndicatorItem = ({ index }) => {
    return (
      <TouchableOpacity
        onPress={() => onChangeIndex(index)}
        activeOpacity={0.6}
        style={[
          styles.indicator,
          indicatorStyle,
          index == currentIndex
            ? indicatorActiveColor
              ? {
                  ...styles.active,
                  ...{
                    backgroundColor: indicatorActiveColor,
                    width: indicatorActiveWidth,
                  },
                }
              : styles.active
            : {
                ...styles.inactive,
                ...{ backgroundColor: indicatorInActiveColor },
              },
        ]}
      />
    );
  };

  return (
    <View style={[styles.container, indicatorContainerStyle]}>
      {indicators.map((item, idx) => (
        <IndicatorItem index={idx} key={idx} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
  },
  indicator: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginRight: 5,
  },
  active: {},
  inactive: {},
});

export default SliderIndicator;
